module.exports = __webpack_public_path__ + "static/media/13goodfools.165c3d4f.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/13goodfools.png
// module id = 112
// module chunks = 0